import React from 'react';
import blogCover from '../images/b1.png';
import blogCover2 from '../images/blog14.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/react-vs-angular-vs-vue"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function ReactVsAngularVsVue() {

    const postDate = "July 23, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            React vs Angular vs Vue: Peregrinee’s Recommendation
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Compare React, Angular, and Vue frameworks and discover
                        Peregrinee’s recommendation for building scalable,
                        modern, and high-performance web applications.
                    </p>

                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="React Angular Vue Comparison"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="Frontend Framework Comparison"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            Why Choosing the Right Framework Matters
                        </h3>

                        <p>
                            Modern web applications rely heavily on powerful
                            JavaScript frameworks to create dynamic user
                            experiences. Choosing the right framework affects
                            performance, scalability, development speed,
                            and long-term maintenance.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            The Three Leading Frameworks
                        </h3>

                        <ul className="ps-3">
                            <li><strong>React:</strong> Flexible and component-based UI library</li>
                            <li><strong>Angular:</strong> Full-featured enterprise framework</li>
                            <li><strong>Vue:</strong> Lightweight and easy-to-learn framework</li>
                        </ul>

                        <p className="mt-3">
                            Each framework serves different project requirements
                            and development approaches.
                        </p>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            React vs Angular vs Vue – Key Differences
                        </h3>

                        <p>
                            These frameworks differ in architecture,
                            flexibility, and ecosystem support.
                        </p>

                        <ul className="ps-3">
                            <li><strong>React:</strong> Component-driven architecture with a massive ecosystem</li>
                            <li><strong>Angular:</strong> Built-in features like dependency injection and routing</li>
                            <li><strong>Vue:</strong> Simpler learning curve with reactive data binding</li>
                            <li><strong>Performance:</strong> React and Vue are generally lightweight</li>
                            <li><strong>Enterprise Support:</strong> Angular is widely used for large enterprise systems</li>
                        </ul>

                        <p className="mt-3">
                            The choice depends on project complexity,
                            scalability goals, and team expertise.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Consult Peregrinee Experts
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="Frontend Framework Selection"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    When to Choose React
                </h2>

                <ul className="ps-3">
                    <li>Building scalable single-page applications</li>
                    <li>Developing SaaS platforms</li>
                    <li>Creating interactive dashboards</li>
                    <li>Projects requiring flexible architecture</li>
                </ul>

                <p className="mt-3">
                    Peregrinee frequently recommends React for startups
                    and SaaS products due to its flexibility and performance.
                </p>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    When Angular or Vue May Be Better
                </h2>

                <ul className="ps-3">
                    <li><strong>Angular:</strong> Enterprise-grade applications with strict architecture</li>
                    <li><strong>Vue:</strong> Lightweight applications or smaller development teams</li>
                    <li>Rapid prototyping and MVP projects</li>
                    <li>Applications requiring simpler frameworks</li>
                </ul>

                <p className="mt-3">
                    The right framework ultimately depends on project scope,
                    scalability needs, and development strategy.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Peregrinee’s Recommendation
                </h2>

                <p>
                    At Peregrinee, we typically recommend React for
                    modern scalable web applications due to its
                    flexibility, strong ecosystem, and performance.
                </p>

                <p>
                    However, our technology selection process always
                    depends on the client’s project goals, scalability
                    expectations, and long-term roadmap.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Discuss Your Web Application Idea
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default ReactVsAngularVsVue;